class Modal {
  constructor(modalId) {
    this.modal = document.getElementById(modalId);
    this.init();
  }

  init() {
    this.elements = {
      content: this.modal.querySelector('.modal__content'),
      success: this.modal.querySelector('.modal__success'),
      error: this.modal.querySelector('.modal__error'),
    };

    this.modal.addEventListener('click', (event) => {
      if (event.target.classList.contains('modal__close') || !this.modal.querySelector('.modal__inner').contains(event.target)) {
        this.close();
      }
    });
  }

  open() {
    this.modal.classList.add('modal_open');

    const modalOpenEvent = new CustomEvent('modal-open', {});
    window.dispatchEvent(modalOpenEvent);
  }

  close() {
    this.resetContent();
    this.modal.classList.remove('modal_open');

    const modalCloseEvent = new CustomEvent('modal-close', {});
    window.dispatchEvent(modalCloseEvent);
  }

  success() {
    if (this.elements.success) {
      this.elements.content?.classList.remove('modal__content_visible');
      this.elements.success.classList.remove('hidden');
      this.elements.error?.classList.add('hidden');
    }
  }

  error() {
    if (this.elements.error) {
      this.elements.content?.classList.remove('modal__content_visible');
      this.elements.success?.classList.add('hidden');
      this.elements.error.classList.remove('hidden');
    }
  }

  resetContent() {
    if (this.elements.content) {
      this.elements.content.classList.add('modal__content_visible');
    }
    if (this.elements.success) {
      this.elements.success.classList.add('hidden');
    }
    if (this.elements.error) {
      this.elements.error.classList.add('hidden');
    }
  }

}